import React,{useState, useContext, useReducer} from 'react';
import { Link } from "react-router-dom";
import MenuContext from '../../components/Context/MenuContext';
function Menu(props) {
    const context = useContext(MenuContext)
    const [isFooter] = useState(props.isFooter)
    return (
        <>
            {context.state && context.state.menuLink.map((menu,i)=>{
                return(
                    <Link hidden={!menu.visible} key={i} to={"/"+menu.to} style={{textDecoration:"none",color:"black"}} onClick={(e)=>context.dispatch({type:"GOTO",payload:menu.position})}>
                        {isFooter ? 
                        <span className="menu-item-footer underline-from-left">{menu.text}</span>
                        : 
                        <span className={context.state.position === menu.position ? "menu-item underline-from-left active-underline":"menu-item underline-from-left "}>{menu.text}</span>
                        }
                    </Link>

                )
            })}

        </>
    );
}

export default Menu;